export const blockIconsPrivacyandsecurityVpnKeyOffNew = (
	<span className='material-symbols-outlined'>vpn_key_off</span>
);
